'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.siteSliders = twentyninetimes.siteSliders || function () {

	function init() {
    let sliders = document.querySelectorAll('.js-slider');
    if ( sliders ) {
      sliders.forEach(slider => {
        testimonialSlider(slider);
      });
    }
	}

  function testimonialSlider(slider) {
    var flky = new Flickity( slider, {
			accessibility: true,
			prevNextButtons: true,
      percentPosition: false,
      adaptiveHeight: true,
			pageDots: false,
      wrapAround: false,
      groupCells: true,
      contain: true,
			on: {
				ready: function() {
					this.resize();
				}
			}
		});
  }

	return {
		init : init
	};

}();